import * as React from 'react'
import RowItem from './preview/row_item'

type PreviewPropsType = {
  elements: any[]
  removeItem: any
  removeItemWithTags: any
  updateItem: any
  makeCopy: any
  clickTagsSelectorControl: any
  imageActions: any
  showAdditions?: boolean
  showImages?: boolean
  visibleColumns?: string[]
}

export default function Preview(props: PreviewPropsType) {
  const { elements, removeItem, removeItemWithTags, updateItem, makeCopy, clickTagsSelectorControl, imageActions, showAdditions, showImages, visibleColumns } = props
  const { I18n } = window as any

  const isColumnVisible = (column: string) => {
    if (!visibleColumns || visibleColumns.length === 0) return true
    return visibleColumns.includes(column)
  }

  return (
    <table className="table table-bordered table-hover table-striped table-sm selected-elements">
      <thead>
        <tr>
          <th className="w-25">
            {I18n.t('activerecord.models.elements/base_element.one')} ({elements.length})
          </th>
          <th className="w-10">{I18n.t('activerecord.attributes.elements/base_element.sku')}</th>
          <th className="w-10">{I18n.t('activerecord.attributes.elements/base_element.min_amount')}</th>
          <th className="w-10">{I18n.t('activerecord.attributes.elements/base_element.max_amount')}</th>
          {isColumnVisible('dimensions') && (
            <th className="w-15">{I18n.t('activerecord.attributes.elements/base_element.dimensions')}</th>
          )}
          {isColumnVisible('pdf') && (
            <th className="w-15">{I18n.t('campaigns.others.pdf')}</th>
          )}
          {isColumnVisible('note') && (
            <th className="w-15">{I18n.t('campaigns.others.note')}</th>
          )}
          {showAdditions && isColumnVisible('additions') && (
            <th className="w-15">{I18n.t('activerecord.models.lists/addition.other')}</th>
          )}
          {isColumnVisible('tags') && (
            <th className="w-15">{I18n.t('activerecord.attributes.elements/common_element.tags')}</th>
          )}
          <th className="w-10">{I18n.t('application.actions.title')}</th>
        </tr>
      </thead>
      <tbody>
        {elements.map((el) => (
          <RowItem
            id={el.elementID}
            key={el.key()}
            item={el}
            updateItem={updateItem}
            removeItem={removeItem}
            removeItemWithTags={removeItemWithTags}
            makeCopy={makeCopy}
            clickTagsSelectorControl={clickTagsSelectorControl}
            imageActions={imageActions}
            showAdditions={showAdditions}
            showImages={showImages}
            visibleColumns={visibleColumns}
          />
        ))}
      </tbody>
    </table>
  )
}
